import React, { useContext, useEffect, useState } from 'react'
import { IonContent, IonPage, useIonAlert } from '@ionic/react'
import { DetailContent, FooterButtons, StyleIonHeader, TextStyle } from '../../../components'
import { StyleIonInput } from '../../../components/atoms/input/StyleIonInput'
import styled from 'styled-components'
import { DivideLineBold } from '../../../components/atoms/divide'
import { RouteComponentProps } from 'react-router'
import { StoresContext } from '../../../provider/StoreProvider'
import { observer } from 'mobx-react'
import { VALIDATE_STATUS_TRADE } from '../../../common'

export const AccountWithdrawal: React.FC<RouteComponentProps> = observer(({ history }) => {
  const [validateStatus, setValidateStatus] = useState<VALIDATE_STATUS_TRADE>(VALIDATE_STATUS_TRADE.INPUT)
  const [withdrawalBalance, setWithdrawalBalance] = useState<number | undefined>()
  const { myStore } = useContext(StoresContext)
  const [presentAlert] = useIonAlert()
  const detailStore = myStore.withdrawalAccountStore
  const currentBalance = detailStore.isLoaded && detailStore.content?.balance

  useEffect(() => {
    detailStore.load(undefined, true)
  }, [])

  const onInputBalance = (inputBalance: number | string) => {
    setWithdrawalBalance(Number(inputBalance))
    if (inputBalance <= 0) {
      setValidateStatus(VALIDATE_STATUS_TRADE.INPUT)
    } else if (inputBalance > Number(currentBalance)) {
      setValidateStatus(VALIDATE_STATUS_TRADE.BALANCE)
    } else {
      setValidateStatus(VALIDATE_STATUS_TRADE.OKAY)
    }
  }

  const onWithdrawalBalance = async () => {
    if (validateStatus === VALIDATE_STATUS_TRADE.OKAY) {
      if (withdrawalBalance == null || withdrawalBalance == undefined) {
        return
      }
      await myStore.withdrawalBalance({ balance: withdrawalBalance })
      presentAlert({
        mode: 'md',
        cssClass: 'custom-alert-alert ',
        header: '출금 처리가 정상적으로 되었습니다.',
        buttons: [
          {
            text: '확인',
            cssClass: 'alert-button-single',
            role: 'confirm',
            handler: () => {
              history.goBack()
            },
          },
        ],
      })
    }
    if (validateStatus === VALIDATE_STATUS_TRADE.BALANCE) {
      presentAlert({
        mode: 'md',
        cssClass: 'custom-alert-alert ',
        header: '출금 금액이 잔액보다 큽니다.',
        buttons: [
          {
            text: '확인',
            cssClass: 'alert-button-single',
          },
        ],
      })
    }
    if (validateStatus === VALIDATE_STATUS_TRADE.INPUT) {
      presentAlert({
        mode: 'md',
        cssClass: 'custom-alert-alert ',
        header: '출금 수량을 입력해주세요.',
        buttons: [
          {
            text: '확인',
            cssClass: 'alert-button-single',
          },
        ],
      })
    }
  }

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'출금'} href={'/myPage/account'} />
      <IonContent>
        <DetailContent detailStore={detailStore}>
          <WithdrawalContainer>
            <IonInputWrap>
              <StyleIonInput
                inputType={'INPUT'}
                type={'number'}
                onInput={onInputBalance}
                placeholder={'출금 수량을 입력해주세요.'}
              />
            </IonInputWrap>
            <TextStyle type={'m_12'}>출금 가능 금액: {detailStore.content?.balance.toLocaleString() ?? 0} 원</TextStyle>
            <TextStyle type={'m_12'} color={'primary_light'}>
              최근 24시간 이내 충전된 금액을 제외한 금액입니다.
            </TextStyle>
          </WithdrawalContainer>
          <DivideLineBold />
          <AccountContainer>
            <TextStyle type={'b_15'}>출금 계좌 정보</TextStyle>
            <ContentWrap>
              <TextStyle type={'r_14'}>은행명</TextStyle>
              <TextStyle type={'r_14'}>{detailStore.content?.withdrawalAccount.bankName ?? '-'}</TextStyle>
            </ContentWrap>
            <ContentWrap>
              <TextStyle type={'r_14'}>계좌번호</TextStyle>
              <TextStyle type={'r_14'}>{detailStore.content?.withdrawalAccount.account ?? '-'}</TextStyle>
            </ContentWrap>
            <ContentWrap>
              <TextStyle type={'r_14'}>예금주</TextStyle>
              <TextStyle type={'r_14'}>{detailStore.content?.withdrawalAccount.bankOwner ?? '-'}</TextStyle>
            </ContentWrap>
          </AccountContainer>
        </DetailContent>
        <InfoContainer>
          <TextStyle type={'sb_13'}>안내</TextStyle>
          <ul>
            <li className="danger">
              보이스피싱 및 금융사고 예방을 위해 24시간 이내 충전된 예치금은 출금이 제한됩니다.
            </li>
            <li>신청하신 금액에서 수수료 1,000원이 제외되고 등록하신 계좌로 입금됩니다.</li>
          </ul>
        </InfoContainer>
      </IonContent>
      <FooterButtons
        button={{ text: '취소', color: 'medium', onClick: () => history.goBack() }}
        rightButton={{ text: '확인', color: 'dark', onClick: () => onWithdrawalBalance() }}
      />
    </IonPage>
  )
})

const WithdrawalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 26px 20px 48px;
  line-height: 14px;
`

const IonInputWrap = styled.div`
  margin: 8px 0;
  ion-input {
    height: 60px;
    border-radius: 8px;
    --padding-start: 15px;
    --padding-end: 15px;
    border: solid 1px var(--ion-color-gray100);
  }
`

const AccountContainer = styled.div`
  padding: 28px 20px 16px 20px;
  border: solid 1px var(--ion-color-gray100);
`

const ContentWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`

const InfoContainer = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  font-size: 1px;
  ul {
    padding-left: 20px;
    font-size: 13px;
    color: #888888;
    line-height: 21px;
    margin: 5px 0;
    .danger {
      color: var(--ion-color-red);
    }
  }
`
